module.exports = __webpack_public_path__ + "static/media/008.c9bf1df2.jpg";